import * as React from 'react';
import { cn } from '@/lib/utils';
import { CardDuelStar } from '@/components/ui/card';

const DuelRequest = React.forwardRef(({ className, isReceived, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-request',
      // Estilos base
      'rounded-[10px] bg-white p-4',
      'shadow-dropshadow',
      'mb-6 max-w-full',
      isReceived && 'border border-solid border-[#fdb462]',
      className
    )}
    {...props}
  />
));
DuelRequest.displayName = 'DuelRequest';

const DuelRequestHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-request-header',
      // Estilo base
      'flex items-center justify-between',
      className
    )}
    {...props}
  />
));
DuelRequestHeader.displayName = 'DuelRequestHeader';

const DuelRequestTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-duel-request-title',
      // Estilo base
      'mb-0 text-sm font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
DuelRequestTitle.displayName = 'DuelRequestTitle';

const DuelRequestTabs = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-request-tabs',
      // Estilo base
      'my-2.5 flex justify-between gap-3',
      className
    )}
    {...props}
  />
));
DuelRequestTabs.displayName = 'DuelRequestTabs';

const DuelRequestTabsItem = React.forwardRef(({ className, isActive, ...props }, ref) => (
  <button
    ref={ref}
    className={cn(
      'c-duel-request-tabs-item',
      // Estilos base
      'cursor-pointer text-xs font-bold text-primary-dark',
      'rounded-[20px] px-2 py-1',
      // Estilos de hover
      'hover:bg-primary hover:text-white',
      // Estilos da variante 'active'
      isActive && 'bg-primary text-white',
      className
    )}
    {...props}
  />
));
DuelRequestTabsItem.displayName = 'DuelRequestTabsItem';

const DuelRequestCard = React.forwardRef(({ className, isClickable, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-request-card',
      // Estilos base
      'mt-3 flex items-center justify-between p-2.5',
      'rounded-[10px] border border-neutral-lightest',
      'shadow-dropshadow',
      'border border-solid border-neutral-lightest',
      // Efeito de hover
      'hover:shadow-[0px_4px_20px_rgba(68,43,140,0.25)]',
      isClickable && 'cursor-pointer',
      className
    )}
    {...props}
  />
));
DuelRequestCard.displayName = 'DuelRequestCard';

const DuelRequestPlayers = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-request-players',
      // Estilo base
      'flex items-center gap-2',
      className
    )}
    {...props}
  />
));
DuelRequestPlayers.displayName = 'DuelRequestPlayers';

const DuelRequestAvatar = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-duel-request-players',
      // Estilo base
      'relative',
      className
    )}
    {...props}
  />
));
DuelRequestAvatar.displayName = 'DuelRequestAvatar';

const DuelRequestStar = React.forwardRef(({ className, ...props }, ref) => (
  <CardDuelStar
    ref={ref}
    className={className}
    {...props}
  />
));
DuelRequestStar.displayName = 'DuelRequestStar';

export { DuelRequest, DuelRequestHeader, DuelRequestTitle, DuelRequestTabs, DuelRequestTabsItem, DuelRequestCard, DuelRequestPlayers, DuelRequestAvatar, DuelRequestStar };
